import { Record } from "immutable";
import moment from "moment";
import { LINK_MEDIA_TYPE_ASSET } from "queries/pages";

const defaults = {
    created_at_ms: undefined,
    created_by_user_id: undefined,
    customer_groups: [],
    description: "",
    hidden: true,
    id: undefined,
    link: "",
    asset: "",
    media: "",
    message: "",
    modified_at_ms: undefined,
    name: "",
    page_id: undefined,
    media_type: LINK_MEDIA_TYPE_ASSET,
};

export class PageLink extends Record(defaults) {
    declare id: string;
    declare name: string;
    declare description?: string;
    declare link: string;
    declare message?: string;
    declare hidden: boolean;
    declare asset: string;
    declare media: string;
    declare media_type: string;
    declare page_id: string;
    declare modified_at_ms: moment.Moment;
    declare created_at_ms: moment.Moment;
    declare created_by_user_id: string;
    declare customer_groups: string[];

    constructor(args) {
        super({
            ...args,
            created_at_ms: moment.utc(args.created_at_ms),
            modified_at_ms: moment.utc(args.modified_at_ms),
        });
    }
}

export interface IPageLinkEntities {
    [id: string]: PageLink;
}
